export default __webpack_public_path__ + "f1a36700f843273cdc3cca0866f1f8ff.svg";